/* eslint-disable react/prefer-stateless-function */
import React, { Component, Suspense } from 'react'
import { Redirect } from 'react-router'

import { SHOPPERS_URL } from 'legacy/common/routes'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import RetailerSwitch from 'legacy/components/RetailerSwitch'
import { routes } from 'domains/shifts/routing/routes'

const Loading = () => null

class ShoppersRoute extends Component<RetailerRouteComponentProps> {
  render() {
    return (
      <Suspense fallback={<Loading />}>
        <RetailerSwitch>
          {/* Shifts has been migrated to its own domain */}
          <Redirect from={SHOPPERS_URL} to={routes.shifts} />
        </RetailerSwitch>
      </Suspense>
    )
  }
}

export default ShoppersRoute
